import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import chroma from "chroma-js";
import blue from "./colors/blue";
import green from "./colors/green";
import grey from "./colors/grey";
import orange from "./colors/orange";
import red from "./colors/red";
import yellow from "./colors/yellow";

let baseSize = 16;
let flexo = "'Flexo', sans-serif";
let opensans = "'Open Sans', sans-serif";

// https://material-ui.com/customization/default-theme/
// https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/styles/createPalette.js
let theme = createMuiTheme({
  palette: {
    common: {
      black: "#000",
      white: "#fff",
      primary: green[500],
      success: green[500],
      secondary: grey[500],
      error: red[500],
      danger: red[500],
      info: blue[500],
      pending: orange[500],
      warning: yellow[500]
    },
    primary: {
      light: green[200],
      main: green[500],
      dark: green[800],
      hover: chroma(green[500])
        .alpha(0.15)
        .css(),
      active: chroma(green[500])
        .alpha(0.28)
        .css()
    },
    // same as primary
    success: {
      light: green[200],
      main: green[500],
      dark: green[800],
      hover: chroma(green[500])
        .alpha(0.15)
        .css(),
      active: chroma(green[500])
        .alpha(0.28)
        .css()
    },
    secondary: {
      light: grey[200],
      main: grey[500],
      dark: grey[600],
      hover: chroma(grey[500])
        .alpha(0.15)
        .css(),
      active: chroma(grey[500])
        .alpha(0.28)
        .css()
    },
    // same as danger
    error: {
      light: red[200],
      main: red[500],
      dark: red[700],
      hover: chroma(red[500])
        .alpha(0.15)
        .css(),
      active: chroma(red[500])
        .alpha(0.28)
        .css()
    },
    // same as error
    danger: {
      light: red[200],
      main: red[500],
      dark: red[700],
      hover: chroma(red[500])
        .alpha(0.15)
        .css(),
      active: chroma(red[500])
        .alpha(0.28)
        .css()
    },
    info: {
      light: blue[200],
      main: blue[500],
      dark: blue[700],
      hover: chroma(blue[500])
        .alpha(0.15)
        .css(),
      active: chroma(blue[500])
        .alpha(0.28)
        .css()
    },
    pending: {
      light: orange[200],
      main: orange[500],
      dark: orange[800],
      hover: chroma(orange[500])
        .alpha(0.15)
        .css(),
      active: chroma(orange[500])
        .alpha(0.28)
        .css()
    },
    warning: {
      light: yellow[200],
      main: yellow[400],
      dark: yellow[600],
      hover: chroma(yellow[500])
        .alpha(0.15)
        .css(),
      active: chroma(yellow[500])
        .alpha(0.28)
        .css()
    },
    action: {
      activeOpacity: 0.54,
      disabledOpacity: 0.26,
      disabledBackgroundOpacity: 0.12,
      hoverOpacity: 0.08,
      selectedOpacity: 0.14
    },
    disabled: {
      light: grey[100],
      main: grey[400],
      dark: grey[700]
    }
  },
  transitions: {
    common: {
      enteringScreen: "225ms cubic-bezier(0.4, 0, 0.2, 1)",
      short: "250ms cubic-bezier(0.4, 0, 0.2, 1)"
    }
  },
  typography: {
    htmlFontSize: baseSize,
    fontFamily: opensans,
    fontFamilyHeader: flexo,
    fontSize: baseSize,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,

    h1: { fontFamily: flexo, fontSize: 48 },
    h2: { fontFamily: flexo, fontSize: 40 },
    h3: { fontFamily: flexo, fontSize: 28 },
    h4: { fontFamily: opensans, fontSize: 24 },
    h5: { fontFamily: opensans, fontSize: 20 },
    h6: { fontFamily: opensans, fontSize: 16 },
    subtitle1: { fontFamily: opensans, fontSize: 16 },
    subtitle2: { fontFamily: opensans, fontSize: 14 },
    body1: { fontFamily: opensans, fontSize: 16 },
    body2: { fontFamily: opensans, fontSize: 14 },
    button: { fontFamily: opensans, fontSize: 14 },
    caption: { fontFamily: opensans, fontSize: 12 },
    overline: { fontFamily: opensans, fontSize: 12 },
    pxToRem: size => `${size / baseSize}rem`
  },
  /*
    MUIs theme object is an array with 25 shadow values (0-24); we only want to
    offer a few. The "none" values are to prevent compilation errors due to MUI
    components relying on the removed shadows. This issue is fixed in MUIv4.4.2
    and can be removed when we upgrade.
  */
  shadows: [
    `0px 0px 6px 0px ${chroma(grey[500]).alpha(0.25)}`,
    `0px 0px 6px 0px ${chroma(grey[500]).alpha(0.55)}`,
    `0px 0px 6px 0px ${chroma(grey[500]).alpha(0.75)}`,
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none"
  ],
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  },
  zIndex: {
    dialog: 1300,
    alert: 1400
  }
});

export default theme;
